import React from 'react';
import {Flex, Text} from "@chakra-ui/layout";
import {Heading, Image, Link} from "@chakra-ui/react";
import PeopleLaptops from '../../images/home/people-laptops.png';
import {NavLink} from "react-router-dom";

function Intro() {
  return (
    <Flex px={7} py={10} flexDirection={{base: "column", lg: "row"}}>
      <Flex flexDirection={"column"} pr={6}>
        <Heading as={"h1"} fontSize={{base: "lg", md: "3xl", lg: "6xl"}} textTransform={"capitalize"} mb={2}
                 lineHeight={{base: "30px", lg: "96px"}}>
          studying <span className={"colored__text"}>online</span> made more easier
        </Heading>
        <Text lineHeight={"20px"} color={"brand.grey"} pr={{base: 2, md: 5, lg: 12}} fontWeight={"semibold"}>
          Vidcom is an e-learning platform that makes teaching online more interactive and you can learn anytime on any
          device.
        </Text>
        <Link as={NavLink} to={"/auth"} textTransform={"capitalize"} color={"brand.darkGreen"} p={4} bgColor={"white"}
              w={'150px'} mt={8} textAlign={"center"} borderRadius={"15px"} fontWeight={"bold"}>
          join for free
        </Link>
      </Flex>
      <Flex mt={{base: 4, lg: 0}} justifyContent={"center"}>
        <Image
          title={"learning environment"}
          src={PeopleLaptops}
          borderRadius={"10px"}
          objectFit="cover"
          alt={"people with laptops"}
        />
      </Flex>
    </Flex>
  );
}

export default Intro;